import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';

export const NoResultsImage = styled(SuiContainer)`
    width: 100%;
    background-size: contain;
    background-position: 50% 50%;
    background-image: url('/assets/images/image-uploader/picture-and-magnifying-glass-sm.png');
    background-repeat: no-repeat;
`;
